<div>
    Name: <input [(ngModel)]="name">
</div>
<div>
    Skill 1: <select [(ngModel)]="skill1">
        <option></option>
        <option [ngValue]="s.name" *ngFor="let s of store.skills">{{s.name}}</option>
    </select>
</div>
<div>
    Skill 2: <select [(ngModel)]="skill2">
        <option></option>
        <option [ngValue]="s.name" *ngFor="let s of store.skills">{{s.name}}</option>
    </select>
</div>
<div>
    Skill 3: <select [(ngModel)]="skill3">
        <option></option>
        <option [ngValue]="s.name" *ngFor="let s of store.skills">{{s.name}}</option>
    </select>
</div>
<div><button (click)="Add()">Hire</button></div>